import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
    selector: 'date-time-renderer',
    templateUrl: './date-time-renderer.component.html',
    standalone: true,
    imports: [CommonModule]
})
export class DateTimeRendererComponent implements ICellRendererAngularComp {
    public text: string;

    constructor() { }

    initilize(params: ICellRendererParams) {
        this.text = params.getValue();
    }

    agInit(params: any): void {
        this.initilize(params);
    }

    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

}
